

import { makeUseList } from '@elentari/core'
import { AgendamentosCandidatoDetail } from '../types'
import { agendamentoCandidatoAdministrativoRepository, agendamentoCandidatoMotoristaRepository } from './agendamentoCandidatoRepository'

export const useAgendamentosCandidatosAdministrativos = makeUseList<AgendamentosCandidatoDetail>(agendamentoCandidatoAdministrativoRepository.fetch)
export const useAgendamentosCandidatosMotoristas = makeUseList<AgendamentosCandidatoDetail>(agendamentoCandidatoMotoristaRepository.fetch)
